module.exports = __webpack_public_path__ + "static/media/Rene Bieder - Campton Book Bold.aff983d2.otf";